import React, { useEffect, useState } from 'react'
import Table from '../components/Table'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Modal from 'react-modal';

export default function About() {



    return (
        <div>

            <form onSubmit={() => { }}>
                <div >
                    <label
                        htmlFor="name_en"

                    >
                        name_en
                    </label>
                    <input
                        type="name_en"

                    />
                </div>
                <div >
                    <label
                        htmlFor="description_en"

                    >
                        description_en
                    </label>
                    <input
                        type="description_en"


                    />
                </div>
                <div >
                    <label
                        htmlFor="code"

                    >
                        code
                    </label>
                    <input
                        type="code"


                    />
                </div>

                <div >
                    <button >
                        add country
                    </button>
                </div>
            </form>




        </div>
    )
}
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',

    },
};